import type { PmNodeConverter, PmNodeJson } from './../../pm-converters/types';
import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { LayoutCellNode, LayoutNode } from './../../ricos-schema/next-schema';

import { getNormalizedColSpans } from './get-normalized-col-spans';

export const layoutConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.LAYOUT],
    // @ts-expect-error next node type
    convert: (node: LayoutNode, visit: (node: LayoutNode | LayoutCellNode) => PmNodeJson[]) => {
      const normalizedColSpans = getNormalizedColSpans(
        node.nodes.map(cell => cell.layoutCellData?.colSpan ?? 0)
      );

      return {
        type: Node_Type.LAYOUT,
        attrs: {
          id: node.id,
        },
        content: node.nodes.map((cell, index) => {
          return {
            type: Node_Type.LAYOUT_CELL,
            attrs: {
              id: cell.id,
              colSpan: normalizedColSpans[index],
            },
            content: visit(cell),
          };
        }),
      };
    },
  },
  fromPm: {
    types: [Node_Type.LAYOUT],
    // @ts-expect-error next node type
    convert: (node: PmNodeJson, visit: (node: PmNodeJson) => LayoutNode[]) => {
      const { attrs = {} } = node;
      const { id } = attrs;

      const areAllColSpansSame = node.content?.every(
        cell => cell.attrs?.colSpan === node.content?.[0].attrs?.colSpan
      );

      const nodeToVisit = areAllColSpansSame
        ? {
            ...node,
            content: node.content?.map(cell => ({
              ...cell,
              ...('attrs' in cell ? { attrs: { ...cell.attrs, colSpan: undefined } } : {}),
            })),
          }
        : node;

      return {
        type: Node_Type.LAYOUT,
        id,
        nodes: visit(nodeToVisit),
      };
    },
  },
};
